export default __webpack_public_path__ + "static/media/ftr4drr.ba6f9aa8.svg";